import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

import CompaniesDashboard from 'routes/Companies';
import IssueManagementDashboard from 'routes/IssueManagementDashboard';
import UserMicroProcessManagementDashboard from 'routes/UserMicroProcessManagementDashboard';
import Report from 'routes/Report';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    height: '100vh',
    boxSizing: 'border-box',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
    height: '100%',
    borderRadius: '10px',
  },
  gridItem: {
    height: '50vh', // half the screen height
  },
}));

const MainPage = (props) => {
  const classes = useStyles();
  const { customProp } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} className={classes.gridItem}>
          <Paper className={classes.paper}>
            <IssueManagementDashboard embedded={true}/>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.gridItem}>
          <Paper className={classes.paper}>
            <UserMicroProcessManagementDashboard  embedded={true}/>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.gridItem}>
          <Paper className={classes.paper}>
             <Report path="/report" customProp="operational" embedded={true}/>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} className={classes.gridItem}>
          <Paper className={classes.paper}>
             <Report path="/report" customProp="regulation" embedded={true}/>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default MainPage;
